import React, { useState, useEffect, useRef} from 'react'
import SelectSearch from 'react-select-search'
import fuzzySearch from '../common/fuzzySearch'
import {configBaseUrl, countries, devices} from '../common/data'
import axios from "axios";
import ShareLink from 'react-twitter-share-link';
import SharefbLink from 'react-facebook-share-link';
import Modal from "react-modal";
import TrialUserRegistrationForm from "../common/TrialUserRegistrationForm";
import SaveReportOscope from './SaveReportOscope';
import {frequencyMonth,NewFrequencyOptionsAll, frequencyOptionsAll, frequencyOptionsDefault, frequencyWeek} from "../common/data/dataTools";

const PageoscopeLive = props => {

	console.log('in PageoscopeLive - b412')

	const toolName = 'mobile_emulator'
	const toolUrl = 'device_emulator'
	const toolType = 'site'
	const featureId = 'PAGE_EMULATOR_URLS'

	const { env, devmode, params, mode } = props

	let publicUrl = configBaseUrl[env] + 'build/'
	let baseUrl = configBaseUrl[env]
	const cannotUseDevMode = ['live', 'staging']
	if (!cannotUseDevMode.includes(env) && devmode === 'Y')
		baseUrl = baseUrl + 'app_dev.php/'

	const [location, setLocation] = useState(false)
	const [accountLevel, setAccountLevel] = useState('BASIC')
	const [usageCount, setUsageCount] = useState(0)
	const [maxUsage, setMaxUsage] = useState(0)
	const [isMMUser, setIsMMUser] = useState(false)
	const [userId, setUserId] = useState(0)
	const [registeredForExtendedUsage, setRegisteredForExtendedUsage] = useState(false)
	const [trialUserRegistered, setTrialUserRegistered] = useState(false)

	const [country, setCountry] = useState('US')
	const [url, setUrl] = useState('')

	const [primaryDevice, setPrimaryDevice] = useState(93)
	const [secondaryDevice, setSecondaryDevice] = useState(63)

	const [submitted, setSubmitted] = useState(false)
	const [submittedOnce, setSubmittedOnce] = useState(false)
	const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true)
	const [submitButtonLabel, setSubmitButtonLabel] = useState('RUN LIVE TEST')
	const [usageAllowed, setUsageAllowed] = useState(true)
	const [defaultParamsExists, setDefaultParamsExists] = useState(false)

	const [autoSubmitFormWhenReady, setAutoSubmitFormWhenReady] = useState(false)

	const [validUrl, setValidUrl] = useState(false)
	const [validForm, setValidForm] = useState(false)
	const [shareUrlLink, setShareUrlLink] = useState('')
	const [shareUrlText, setShareUrlText] = useState('')
	const [shareFbUrlLink, setShareFbUrlLink] = useState('')
	const [livePage, setLivePage] = useState(true)

	const [displayTrialUserRegistrationFormModalIsOpen, setDisplayTrialUserRegistrationFormModalIsOpen] = useState(false);

	const [saveTestPopUpIsOpen, setSaveTestPopUpIsOpen] = useState(false)
   const [saveTestData, setSaveTestData] = useState([])
   const [selectedFrequency,SetSelectedFrequency] = useState('1')
   const [frequencyText,setFreqencyText] = useState('')
   const [displayClass, setDisplayClass] = useState('hidden')
   const [frequencyAmount,setFrequencyAmount] = useState(dateDayOfMonth)
   const [frequencyAmounts, setFrequencyAmounts] = useState([])
   const [displayFrequencyAmount,setDisplayFrequencyAmount] = useState('hidden')
   const [selectedFrequencyName,setSelectedFrequencyName] = useState('Once Only')

   const [selectedAddress, setSelectedAddress] = useState(null);
   const [addresses, setAddresses] = useState([]);
   const [city, setCity] = useState('');
   const [state, setState] = useState('');
   const [address, setAddress] = useState('');

   const twitterTab = useRef(null)
   const fbTag = useRef(null)

   let todaysDate = new Date()
   let dateDayOfMonth = todaysDate.getDate();
   let dateDayOfWeek = todaysDate.getDay() + 1;
   const saveTestModalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
			border: 'none',
            padding: 0,
            background: 'transparent',
            transition: 'all 5000ms ease-in-out'
        }
      };

	const standardModalStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
			border: 'none',
			padding: 0,
			background: 'transparent'
		},
	};

	useEffect(() => {
		const setLocationParam = true;
		axios.get(baseUrl + 'tools/can-use-tool/' + toolUrl + '?set_location=' + setLocationParam + '&mode=' + mode + '&live_page=' + livePage)
		let set_location = true

		console.log('params',params)

		if( params > '') {
			let paramsParts = JSON.parse(params)
			if (paramsParts.url ) {
				setUrl(paramsParts.url)
				setAutoSubmitFormWhenReady(true)
				setDefaultParamsExists(true)
			}
			if (paramsParts.country_code ) {
				setCountry(paramsParts.country_code)
				set_location = false
			}
			if (paramsParts.device1) {
				setPrimaryDevice(paramsParts.device1)
			}
			if (paramsParts.device2) {
				setSecondaryDevice(paramsParts.device2)
			}

		}


		axios.get(baseUrl + 'tools/can-use-tool/' + toolUrl + '?set_location=' + set_location + '&mode=' + mode)
			.then(r => {
				console.log('can-use-tool response:', r.data)
				if( r.data.location ) {
					setLocation(r.data.location)
					if ( r.data.location.country_code) {
						console.log('set country to ', r.data.location.country_code)
						setCountry(r.data.location.country_code)
					}
				}
				if( r.data.accountLevel )
					setAccountLevel(r.data.accountLevel)

				if( mode === 'demo' ) {
					if (r.data.userId && r.data.userId > 0) {
						setUserId(r.data.userId)
						// setPublicUsage(false)
						if (r.data.isMMUser)
							setIsMMUser(r.data.isMMUser)
						if (r.data.accountLevel)
							setAccountLevel(r.data.accountLevel)
					} else {
						// setPublicUsage(true)
						if (r.data.publicUsageAccessDetails.maxUsage)
							setMaxUsage(r.data.publicUsageAccessDetails.maxUsage)
						if (r.data.publicUsageAccessDetails.usageCount)
							setUsageCount(r.data.publicUsageAccessDetails.usageCount)
					}
				}
			})
			.catch(e => {
				console.log(e)
			})

		window.addEventListener('copyToClipboard',(data)=>{
	        console.log('copyToClipboard data',data.detail);
	            if(data.detail.sharingLink != '')
	            {
	            	navigator.clipboard.writeText(data.detail.sharingLink)
	            }
	          window.removeEventListener('copyToClipboard', null)
	    })

	    window.addEventListener('twitterbtn',(data)=>{
	        console.log('twitterbtn data',data.detail);
	            if(data.detail.url != '')
	            {
	            	setShareUrlLink(data.detail.url)
	            	setShareUrlText(data.detail.message)
	            	twitterTab.current.click()
	            }
	          window.removeEventListener('twitterbtn', null)
	    })

	    window.addEventListener('facebookbtn',(data)=>{
	        console.log('facebookbtn data',data.detail);
	            if(data.detail.url != '')
	            {
	            	fbTag.current.click()
	            	setShareFbUrlLink(data.detail.url)
	            }
	          window.removeEventListener('facebookbtn', null)
	    })

	}, [])
	useEffect(()=>{
	   window.addEventListener('setOscopePopUpFunction',(data)=>{
		   console.log('received popup data',data.detail);
		   if(data.detail.type==='popup_data')
		   {
			   if(data.detail.data)
			   {
				   // console.log('popup_data');
				   // console.log(data.detail.data)
					saveTestReportModalOpen()
			   }
		   }
	   })
  },[]);
	useEffect(() => { validateForm() }, [ url, country, primaryDevice, secondaryDevice ])

	useEffect(() => {
		// console.log('in useEffect validForm && autoSubmitFormWhenReady ', validForm, autoSubmitFormWhenReady)
		if( validForm && autoSubmitFormWhenReady ){
			setAutoSubmitFormWhenReady(false)
			submitFormClick()
		}
	}, [ validForm, autoSubmitFormWhenReady ])

	if( mode === 'demo' ) {

		useEffect(() => {
			// console.log('TUR - trialUserRegistered', trialUserRegistered)
			// will be updated after the user registers
			if( trialUserRegistered )
				setSubmitButtonDisabled(false)
				setUsageAllowed(true)
			}, [ trialUserRegistered ])

		useEffect(() => {
			if( setUsageAllowed)
				setSubmitButtonLabel('RUN LIVE TEST')
			else
				setSubmitButtonLabel('SIGN UP')
			}, [ setUsageAllowed ])

		useEffect(() => {
			// console.log('TUR - usageCount or maxUsage changed', registeredForExtendedUsage, usageCount, maxUsage)
			checkUsage()
		}, [usageCount, maxUsage])
	}

	const checkUsage = () => {
		if (userId === 0 && !registeredForExtendedUsage && maxUsage > 0 && usageCount > maxUsage) {
			// console.log('TUR - display reg form 1')
			setSubmitButtonDisabled(true)
			setUsageAllowed(false)
			setDisplayTrialUserRegistrationFormModalIsOpen(true)
		} else if (userId === 0 && registeredForExtendedUsage && maxUsage > 0 && usageCount > maxUsage) {
			setTimeout(() => {
				// console.log('TUR - reload page 1')
				// window.location.reload();
			}, 1000);
		} else if( userId === 0 && usageCount === 0 ) {
			if( defaultParamsExists && !autoSubmitFormWhenReady)
				setAutoSubmitFormWhenReady(true)
		}
	}

	const checkUsageOnSubmit = () => {
		if (userId === 0 && !registeredForExtendedUsage && maxUsage > 0 && usageCount === maxUsage) {
			// console.log('TUR - display reg form 2')
			setSubmitButtonDisabled(true)
			setUsageAllowed(false)
			setDisplayTrialUserRegistrationFormModalIsOpen(true)
		} else if (userId === 0 && registeredForExtendedUsage && maxUsage > 0 && usageCount === maxUsage) {
			setTimeout(() => {
				// console.log('TUR - reload page 2')
				window.location.reload()
			}, 1000);
		}
	}

	const handleFetchEmulatorHtml = () => {
		let phoneIds = []
		if (primaryDevice > 0)
			phoneIds.push(primaryDevice)
		if (secondaryDevice > 0)
			phoneIds.push(secondaryDevice)

		var params = {
			'type': toolType,
			'tool': toolName,
			'feature_htmloutput': 0,
			'feature_htmloutputBot': 0,
			'feature_screenshothtmloutput': 0,
			'site_url': url,
			'phoneids_arr': phoneIds,
			'public_usage': mode !== 'member',
			'mm_mode': mode,
			'address' : address,
			'suburb' : "",
			'city' : city,
			'state' : state
		};

		if( isNaN(country)) {
			params.country_code = country
			params.country = country
		}
		else
			params.country_id = country

		// console.log('params', params)

		axios.post(baseUrl + 'tools/display/' + toolUrl, {'params': params})
			.then(r => {
				document.getElementById('emulator_div').innerHTML = r.data
				setSubmitButtonDisabled(false)
				setSubmittedOnce(true)
			})
			.catch(e => {
				console.log(e)
			})
	}

	const checkPublicUsageAccess = () => {
		axios.get(baseUrl + 'tools/public_usage-access/' + featureId)
		.then(r => {
			// console.log('public_usage-access response:', r.data)
			if( ! r.data.publicUsageAccess){
				setSubmitButtonDisabled(true)
				window.location.reload();
			}
		})
		.catch(e => {
			console.log(e)
		})
	}

	const checkIfValidUrl = (url) => {

		// check for invalid urls:
		if( url.indexOf('mobilemoxie.com/tools/mobile-page-test') !== -1)
			return false;

		// source: https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
		let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
		return regexp.test(url)
	}

	const validateForm = () => {
		setSubmitted(false)
		let isValidUrl = checkIfValidUrl(url)
		setValidUrl(isValidUrl)

		const isValidForm = country !== '' && isValidUrl && (primaryDevice > 0 || secondaryDevice > 0)

		// console.log('in validateForm', isValidForm, autoSubmitFormWhenReady)

		saveTestDataArray = {};
		saveTestDataArray['country'] = country;
		saveTestDataArray['url'] = url;
		setSaveTestData(saveTestDataArray);
		setValidForm(isValidForm)
		setSubmitButtonDisabled(!isValidForm)

		// console.log('in validateForm', isValidForm, isValidForm, country !== '', primaryDevice > 0)
	}

	const submitFormClick = () => {
		// console.log('in submitFormClick',validForm, mode, usageAllowed, usageCount < maxUsage)

		// set form as submitted (if valid)
		setSubmitted(validForm)

		if( validForm ) {
			if( mode === 'demo' ) {
				if( userId > 0 )
					handleFetchEmulatorHtml()
				else {
					if (usageAllowed) {
						if (usageCount < maxUsage) {
							setUsageCount(usageCount + 1)
							handleFetchEmulatorHtml()
						} else
							checkUsageOnSubmit()
					} else if (!registeredForExtendedUsage) {
						setDisplayTrialUserRegistrationFormModalIsOpen(true)
					}
				}
			} else
				handleFetchEmulatorHtml()
			setSubmitButtonDisabled(true)
		}
	}

	// close modal
	function displayTrialUserRegistrationFormModalClose() {
		setDisplayTrialUserRegistrationFormModalIsOpen(false)
	}

	function saveTestReportModalOpen(){
        setSaveTestPopUpIsOpen(true);
    }
    function saveTestReportModalClose(){
        setSaveTestPopUpIsOpen(false);
    }
    const settingDisplayLocality = (value) => {
       // console.log('in set display locality .....');
       // console.log(displayClass);

       if(value == 1){
               setDisplayClass('hidden')
               setDisplayFrequencyAmount('hidden')
               setSubmitButtonDisabled(false)
               SetSelectedFrequency('1')
               setSelectedFrequencyName('Once Only')
       }
       if(value == 2){
               setDisplayClass('')
               setDisplayFrequencyAmount('');
               setFrequencyAmounts(frequencyWeek);
               setFreqencyText('now and then every');
               setSubmitButtonDisabled(true)
               SetSelectedFrequency('2')
               setSelectedFrequencyName('Weekly')

       }
       if(value == 3){
            setDisplayFrequencyAmount('');
            setFrequencyAmounts(frequencyMonth)
            setFreqencyText('now and then on the')
            setDisplayClass('')
            setSubmitButtonDisabled(true)
            setSelectedFrequencyName('Monthly')
            SetSelectedFrequency('3')
       }
       if(value == 4)
       {
               setDisplayClass('')
               setDisplayFrequencyAmount('hidden')
               setSubmitButtonDisabled(true)
               SetSelectedFrequency('4')
               setSelectedFrequencyName('Daily')
       }
    }
     const setFrequencyAmountData=(e)=>{
    	// console.log('in set frequnecy Amount Data section with frequency : '+ e)
    	setFrequencyAmount(e)
    }

	useEffect(() => {
		// Fetch addresses data from the endpoint
		axios.get(baseUrl + 'tools/get-client-addresses')
			.then(response => {
				if (response.data.items.length === 0) {
					setAddresses([]);
				} else {
					const parsedAddresses = response.data.items.map(item => {
						const addressData = JSON.parse(item.value);
						return {
							id: addressData.id,
							city: addressData.city,
							state: addressData.state,
							displayAddress: addressData.displayAddress
						};
					});
					setAddresses(parsedAddresses);
				}
			})
			.catch(error => {
				console.error('Error fetching addresses:', error);
				setAddresses([]);
			});
	}, []);

	const handleSelectedAddress = (value) => {
		if (typeof value === 'number') {
			const selectedAddressObject = addresses.find(address => address.id === value);

			if (!selectedAddressObject) {
				console.error('Selected address not found');
				return;
			}

			const { city, state, displayAddress } = selectedAddressObject;

			setCity(city);
			setState(state);
			setAddress(displayAddress);
			setSelectedAddress(selectedAddressObject);
		} else {
			const [city, state, address] = value.split(',').map(item => item.trim());

			if (value.length > 0) {
				if (!city || !state || !address) {
					$('#input-address-div').addClass('has-error');
					setSubmitButtonDisabled(true)
				} else {
					$('#input-address-div').removeClass('has-error');
					setSubmitButtonDisabled(false);
				}
			} else {
				$('#input-address-div').removeClass('has-error');
				setSubmitButtonDisabled(false);
			}

			const selectedAddressObject = {
				id: null,
				city: city,
				state: state,
				address: address,
				displayAddress: address
			};

			setCity(city);
			setState(state);
			setAddress(address);
			setSelectedAddress(selectedAddressObject);
		}
	};
		
	return (
		<div className='PageoscopeLive'>
			<div className='container-fluid'>
				<ShareLink link={shareUrlLink} text={shareUrlText}>
                  {link => (
                     <a ref={twitterTab} href={link} target='_blank' className="hidden">Share this on Twitter</a>
                  )}
               </ShareLink>

               <SharefbLink link={shareFbUrlLink}>
				   {link => (
				      <a ref={fbTag} href={link} target='_blank' className="hidden">Share this on Facebook</a>
				   )}
				</SharefbLink>
				<div className='row'>
					<div className='tab-content live-testing'>
						<div id="simulator_control_tab">
							<div className='row'>
								<div className='col-xs-12 col-sm-4 col-md-3'>
									<label className='control-label'>Country<span className='required'>*</span></label>
									<div className='form-group has-feedback has-error'>
										<div className='input-section'>
											<SelectSearch
												search
												autoComplete='nope'
												emptyMessage='Not found'
												placeholder='Select a country'
												value={country}
												options={countries}
												filterOptions={fuzzySearch}
												onChange={setCountry} />
										</div>
										{submitted && country === '' && (<span className='error'>Please choose a country from the list above</span>)}
									</div>
								</div>
								{addresses.length > 0 ? (
									<div className="col-xs-12 col-sm-4 col-md-3">
										<label className="control-label">Address</label>
										<div className="form-group has-feedback has-error">
											<div className="input-section">
												<SelectSearch
													search
													autoComplete="nope"
													emptyMessage="Not found"
													placeholder="Select an address"
													value={selectedAddress ? selectedAddress.id : null}
													options={addresses.map(address => ({
														value: address.id,
														name: address.displayAddress
													}))}
													filterOptions={fuzzySearch}
													onChange={handleSelectedAddress}
												/>
											</div>
											{submitted && country === '' && (<span className="error">Please choose a country from the list above</span>)}
										</div>
									</div>
								) : null}
								<div className={`col-xs-12 col-sm-4 col-md-3${addresses.length === 0 ? '' : ' hidden'}`}>
									<label className='control-label'>Address</label>
									<div className='form-group has-feedback' id='input-address-div'>
										<div className='input-section'>
											<input
												type='text'
												className='form-control'
												placeholder='City, State, Example Street 25'
												onChange={(e) => handleSelectedAddress(e.target.value)}
											/>
										</div>
										{submitted && country === '' && (<span className='error'>Please choose a country from the list above</span>)}
									</div>
								</div>
								<div className='col-xs-12 col-sm-4 col-md-6'>
									<label className='control-label'>URL To Test <span className='required'>*</span></label>
									<div className={submittedOnce && !checkIfValidUrl(url) ? 'form-group has-feedback has-error' : 'form-group has-feedback'}>
										<div className='input-section'>
											<input type='text' value={url} onChange={e => setUrl(e.target.value)} className='form-control' />
										</div>
										{submittedOnce && !checkIfValidUrl(url) && (<span className='error'>Please enter a valid URL</span>)}
									</div>
								</div>
							</div>

							<div className='row mt-10'>
								<div className='col-xs-12 col-sm-6'>
									<label className='control-label'>First Device <span className='required'>*</span></label>
									<div className='form-group has-feedback has-error'>
										<div className='input-section'>
											<SelectSearch
												search
												autoComplete='nope'
												emptyMessage='Not found'
												placeholder='Select a device'
												value={primaryDevice}
												options={devices}
												filterOptions={fuzzySearch}
												onChange={v => setPrimaryDevice(parseInt(v))} />
										</div>
										{submitted && primaryDevice === '' && (<span className='error'>Please choose a device from the list above</span>)}
									</div>
								</div>
								<div className='col-xs-12 col-sm-6'>
									<label className='control-label'>Second Device (optional)</label>
									<div className='form-group'>
										<div className='input-section'>
											<SelectSearch
												search
												autoComplete='nope'
												emptyMessage='Not found'
												placeholder='Select a device'
												value={secondaryDevice}
												options={devices}
												filterOptions={fuzzySearch}
												onChange={v => setSecondaryDevice(parseInt(v))} />
										</div>
									</div>
								</div>
							</div>
							<div className='row'>
								<div className="col-xs-12 text-center text-center-xs mt-20">
									<input disabled={submitButtonDisabled} type="button" className="btn btn-primary" value={submitButtonLabel} onClick={() => submitFormClick()} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="search-results-container tool-ui">
				<div id='emulator_div' className="results-wrapper"></div>
			</div>

			<div className={'row' + (mode === 'member' ? ' mb-80' : '')}>
				<div className="col-xs-12">
					<div className={mode === 'member' ? 'pa-20 bg-white' : 'pt-20'}>
						<div className="row">
							<div className="col-xs-12 text-center captcha-note">
								Note about CAPTCHAs:<br />
								As you explore our Toolset, you may encounter CAPTCHA in your searches. Please click
								through the CAPTCHA, as this will help Google recognize that our users are indeed humans
								and not robots. Thanks!
							</div>
						</div>
					</div>
				</div>
			</div>

			<Modal
				isOpen={displayTrialUserRegistrationFormModalIsOpen}
				onRequestClose={displayTrialUserRegistrationFormModalClose}
				contentLabel="User Registration"
				style={standardModalStyles}
			>
				<TrialUserRegistrationForm
					publicUrl={publicUrl}
					baseUrl={baseUrl}
					toolUrl={toolUrl}
					setUsageAllowed={setUsageAllowed}
					setRegisteredForExtendedUsage={setRegisteredForExtendedUsage}
					setMaxUsage={setMaxUsage}
					setTrialUserRegistered={setTrialUserRegistered}
					displayTrialUserRegistrationFormModalClose={displayTrialUserRegistrationFormModalClose}
				/>
			</Modal>

 			<Modal
                    isOpen={saveTestPopUpIsOpen}
                    onRequestClose={saveTestReportModalClose}
                    contentLabel="Save Test"
				    style={saveTestModalStyles}
            >
               <SaveReportOscope
                    baseUrl={baseUrl}
                    publicUrl={publicUrl}
                    SaveReportPopUpClose={saveTestReportModalClose}
                    saveTestData={saveTestData}
                    accountLevel = {accountLevel}
                    selectedFrequency={selectedFrequency}
                    SetSelectedFrequency={SetSelectedFrequency}
                    frequencyText={frequencyText}
                    setFreqencyText={setFreqencyText}
                    displayClass={displayClass}
                    settingDisplayLocality={settingDisplayLocality}
                    setDisplayClass={setDisplayClass}
                    frequencyAmount={frequencyAmount}
                    setFrequencyAmount={setFrequencyAmount}
                    frequencyAmounts={frequencyAmounts}
                    setFrequencyAmounts={setFrequencyAmounts}
                    displayFrequencyAmount={displayFrequencyAmount}
                    setDisplayFrequencyAmount={setDisplayFrequencyAmount}
                    selectedFrequencyName={selectedFrequencyName}
                    setSelectedFrequencyName={setSelectedFrequencyName}
                    setFrequencyAmountData={setFrequencyAmountData}
                    >
                </SaveReportOscope>
            </Modal>
		</div>
	)
}

export default PageoscopeLive